<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">{{data.content}}</div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <div *ngIf="data?.id > 0">
            <button mat-button class="btn btn-danger yes-button" (click)="deleteYear()"
                *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{data.confirmText}}</button>
        </div>
        <div *ngIf="!data?.id">
            <button mat-button class="btn btn-danger yes-button" (click)="deleteSelectedPeriod()"
                *ngIf="!isLoading; else loadingTemplate">
                {{data.confirmText}}
            </button>
        </div>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-danger yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>